import { createApp } from 'vue'
import { reactive } from "vue"
import App from './App.vue'
import mainRouter from './router.js'
import store from "./store.js"
import '@/assets/styles/main.scss'  // 전역 스타일 (한 번만 로드)

//let emitter = mitt();
let app = createApp(App)
//app.config.globalProperties.emitter = emitter;

//createApp(App).use(mainRouter).mount('#app')
app.use(mainRouter);
app.use(store);
app.provide("user",reactive({}));
app.mount('#app')